import React from "react";
import "./Footer.scss";

export default function Footer() {
  return (
    <div className="public-group-footer">
      This is a public group powered by notata. Notata is a tool for investors, by investors. Like what you see? Sign up to a <a href="https://notata.io/signup">free account here</a>.
    </div>
  )
}